/* globals angular */
import CodeMirror from 'codemirror'

export default ['$compile', '$timeout', '$rootScope', directive]

function directive($compile, $timeout, $rootScope) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: {
      pre: ($scope, element, attrs, ngModel) => {
        // Require CodeMirror
        if (angular.isUndefined(CodeMirror)) {
          throw new Error('codeEditor directive needs CodeMirror to work')
        }
      },
      post: ($scope, element, attrs, ngModel) => {
        // Require Textarea element
        if (element[0].tagName !== 'TEXTAREA') {
          throw new Error('codeEditor can only be used on textarea')
        }

        // Require value as string
        if (angular.isObject(attrs.value) || angular.isArray(attrs.value)) {
          throw new Error('codemirror cant an object or an array as the model')
        }

        // CodeMirror Object
        let codeEditor

        // CodeMirror Options
        let options = {
          value: attrs.value || '',
          mode: attrs.mode || 'htmlmixed',
          lineNumbers: attrs.lineNumbers || true,
          theme: attrs.theme || 'default',
          autofocus: attrs.autofocus || false,
        }

        let cursorAtTop = false
        let cursorAtBot = false

        const onKeyUpArrows = (inst, e) => {
          let isUpArrow = e.which === 38
          let isDownArrow = e.which === 40
          let shouldExit =
            (cursorAtTop && isUpArrow) || (cursorAtBot && isDownArrow)
          if (!shouldExit) {
            e.stopPropagation()
          }

          cursorAtTop = inst.doc.getCursor().line === inst.doc.firstLine()
          cursorAtBot = inst.doc.getCursor().line === inst.doc.lastLine()
        }

        // Init CodeMirror
        function init() {
          // some race condition between codemirror
          // building references to dom and angular...maybe
          $timeout(() => {
            codeEditor = CodeMirror.fromTextArea(element[0], options)
            // Keep the ngModel in sync with changes from CodeMirror
            codeEditor.on('change', (i) => {
              let newValue = i.getValue()
              if (newValue !== ngModel.$viewValue) {
                $scope.$evalAsync(() => {
                  ngModel.$setViewValue(newValue)
                })
              }
            })

            // forward focusing
            codeEditor.on('focus', () => element[0].focus())

            // don't forward arrowkey events unless we are at the ends.
            codeEditor.on('keyup', onKeyUpArrows)

            codeEditor.on('paste', (cm, evt) => evt.stopPropagation())

            // TODO: HACK: stop-gap, we should refresh more judiciously, pub-sub could make it better.
            window.setInterval(() => codeEditor.refresh(), 666) // 2/3 of a second, so metal

            // add easy access to code mirror object
            element.closest('[feature]').data('codeEditor', codeEditor)
          }, 0)
        }

        // Refresh CodeMirror
        function refresh() {
          // Race Conditions...again
          $timeout(() => {
            codeEditor.refresh()
            // TODO: Mike : fix cursor but of autofocus
            // codeEditor.getInputField().blur()
          }, 0)
        }

        // Watch for Compose tab
        // $scope.$on('Tab.Change', ( e, data )=>{})
        $scope.$watch('activeTab', (a, b) => {
          if (a !== b && a === 'tab-compose') {
            refresh()
          }
        })

        // Init CodeMirror instance
        init()
      },
    },
  }
}
